import React, { useState } from 'react';
import { 
  Package,
  ShoppingCart,
  Truck,
  Building,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Clock,
  Eye,
  Trash2,
  Download,
  Plus,
  Edit,
  Save,
  X,
  Search,
  Filter,
  MoreHorizontal,
  Bookmark,
  Star,
  Share,
  Info,
  ExternalLink,
  Archive,
  Send,
  Flag,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Upload,
  FileUp,
  FileDown,
  FileCheck,
  FileX,
  Volume2,
  VolumeX,
  Headphones,
  Speaker,
  Radio,
  Music,
  Video,
  Camera,
  Image,
  File,
  Folder,
  FolderOpen,
  HardDrive,
  Cloud,
  Wifi,
  WifiOff,
  Signal,
  Battery,
  BatteryLow,
  Power,
  PowerOff,
  Activity,
  Zap,
  Shield,
  Lock,
  Key,
  Users,
  Calendar,
  Phone,
  Mail,
  MapPin,
  CheckSquare,
  Square as SquareIcon,
  ArrowUpRight,
  ArrowDownRight,
  ArrowLeft,
  Home,
  Wrench,
  FileBarChart,
  Cog,
  Settings,
  Link,
  Monitor,
  Tablet,
  Smartphone,
  Lightbulb,
  Cpu,
  Network,
  Database,
  Layers,
  User,
  Languages,
  Mic,
  Play,
  Pause,
  Square,
  RefreshCw,
  Copy,
  Globe,
  Users2,
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  Clock as ClockIcon,
  Target,
  Brain,
  MessageSquare,
  AlertCircle,
  CheckSquare as CheckSquareIcon,
  Receipt,
  Bot,
  Scan,
  Zap as ZapIcon,
  Shield as ShieldIcon,
  LineChart,
  BarChart,
  PieChart,
  AreaChart,
  TrendingUp,
  TrendingDown,
  ArrowUp,
  ArrowDown,
  Minus,
  Percent,
  Calendar as CalendarIcon,
  AlertCircle as AlertCircleIcon,
  Info as InfoIcon,
  Lightbulb as LightbulbIcon,
  Award,
  Gift,
  Coins,
  Wallet,
  PiggyBank,
  Banknote,
  Receipt as ReceiptIcon,
  ShoppingCart as ShoppingCartIcon,
  Package as PackageIcon,
  Truck as TruckIcon,
  Building2,
  Factory,
  Store,
  Home as HomeIcon,
  Car,
  Plane,
  Train,
  Ship,
  Fuel,
  Wrench as WrenchIcon,
  Tool,
  Hammer,
  Screwdriver,
  Cog as CogIcon,
  Settings as SettingsIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  Activity as ActivityIcon,
  Zap as ZapIcon2,
  Target as TargetIcon,
  Brain as BrainIcon,
  Database as DatabaseIcon,
  Layers as LayersIcon,
  Network as NetworkIcon,
  Cpu as CpuIcon,
  Monitor as MonitorIcon,
  Smartphone as SmartphoneIcon,
  Tablet as TabletIcon,
  Globe as GlobeIcon,
  Users as UsersIcon,
  Building as BuildingIcon,
  Home as HomeIcon2,
  Car as CarIcon,
  Plane as PlaneIcon,
  Train as TrainIcon,
  Ship as ShipIcon,
  Truck as TruckIcon2,
  Package as PackageIcon2,
  ShoppingCart as ShoppingCartIcon2,
  Receipt as ReceiptIcon2,
  Banknote as BanknoteIcon,
  PiggyBank as PiggyBankIcon,
  Wallet as WalletIcon,
  Coins as CoinsIcon,
  Gift as GiftIcon,
  Award as AwardIcon,
  Lightbulb as LightbulbIcon2,
  Info as InfoIcon2,
  AlertCircle as AlertCircleIcon2,
  Clock as ClockIcon2,
  Calendar as CalendarIcon2,
  Percent as PercentIcon,
  Minus as MinusIcon,
  ArrowDown as ArrowDownIcon,
  ArrowUp as ArrowUpIcon,
  TrendingDown as TrendingDownIcon,
  TrendingUp as TrendingUpIcon,
  AreaChart as AreaChartIcon,
  Shield as ShieldIcon2,
  Scan as ScanIcon,
  Bot as BotIcon,
  CheckSquare as CheckSquareIcon2,
  MessageSquare as MessageSquareIcon,
  Brain as BrainIcon2,
  Target as TargetIcon2,
  Zap as ZapIcon3,
  Activity as ActivityIcon2,
  BarChart as BarChartIcon2,
  PieChart as PieChartIcon2,
  LineChart as LineChartIcon,
  TrendingDown as TrendingDownIcon2,
  TrendingUp as TrendingUpIcon2,
  Calculator as CalculatorIcon,
  CreditCard as CreditCardIcon,
  DollarSign as DollarSignIcon,
  FileText as FileTextIcon,
  Eye as EyeIcon,
  Trash2 as Trash2Icon,
  Edit as EditIcon,
  Save as SaveIcon,
  X as XIcon,
  Plus as PlusIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Bookmark as BookmarkIcon,
  Star as StarIcon,
  Share as ShareIcon,
  Info as InfoIcon3,
  ExternalLink as ExternalLinkIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Flag as FlagIcon,
  Heart as HeartIcon,
  ThumbsUp as ThumbsUpIcon,
  ThumbsDown as ThumbsDownIcon,
  Upload as UploadIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Headphones as HeadphonesIcon,
  Speaker as SpeakerIcon,
  Radio as RadioIcon,
  Music as MusicIcon,
  Video as VideoIcon,
  Camera as CameraIcon,
  Image as ImageIcon,
  File as FileIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  HardDrive as HardDriveIcon,
  Cloud as CloudIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Signal as SignalIcon,
  Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Activity as ActivityIcon3,
  Zap as ZapIcon4,
  Shield as ShieldIcon3,
  Lock as LockIcon,
  Key as KeyIcon,
  Users as UsersIcon2,
  Building as BuildingIcon2,
  Calendar as CalendarIcon3,
  Phone as PhoneIcon,
  Mail as MailIcon,
  MapPin as MapPinIcon,
  CheckSquare as CheckSquareIcon3,
  Square as SquareIcon2,
  ArrowUpRight as ArrowUpRightIcon,
  ArrowDownRight as ArrowDownRightIcon,
  ArrowLeft as ArrowLeftIcon,
  Home as HomeIcon3,
  Wrench as WrenchIcon2,
  FileBarChart as FileBarChartIcon,
  Cog as CogIcon2,
  Settings as SettingsIcon2,
  Link as LinkIcon,
  Monitor as MonitorIcon2,
  Tablet as TabletIcon2,
  Smartphone as SmartphoneIcon2,
  Lightbulb as LightbulbIcon3,
  Cpu as CpuIcon2,
  Network as NetworkIcon2,
  Database as DatabaseIcon2,
  Layers as LayersIcon2,
  User as UserIcon,
  Languages as LanguagesIcon,
  Mic as MicIcon,
  Play as PlayIcon,
  Pause as PauseIcon,
  Square as SquareIcon3,
  RefreshCw as RefreshCwIcon,
  Copy as CopyIcon,
  Download as DownloadIcon,
  Globe as GlobeIcon2,
  Users2 as Users2Icon,
  AlertTriangle as AlertTriangleIcon2,
  CheckCircle as CheckCircleIcon2,
  XCircle as XCircleIcon2,
  Clock as ClockIcon3,
  Target as TargetIcon3,
  Brain as BrainIcon3,
  MessageSquare as MessageSquareIcon2,
  AlertCircle as AlertCircleIcon3,
  CheckSquare as CheckSquareIcon4
} from 'lucide-react';
import DataTable from '../common/DataTable';
import ConfirmationModal from '../common/ConfirmationModal';

const ProcurementIntegration = () => {
  const [activeTab, setActiveTab] = useState('purchase-orders');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Mock data for purchase orders
  const [purchaseOrders, setPurchaseOrders] = useState([
    {
      id: 'PO-001',
      orderNumber: 'PO-2024-001',
      vendor: 'TechCorp Solutions',
      status: 'Approved',
      orderDate: '2024-02-15',
      expectedDelivery: '2024-02-25',
      totalAmount: '$15,750.00',
      currency: 'USD',
      items: 12,
      category: 'IT Equipment',
      department: 'IT',
      createdBy: 'John Smith',
      approvedBy: 'Sarah Johnson',
      isActive: true,
      tags: ['it-equipment', 'approved', 'urgent'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 45,
      downloadCount: 8,
      aiInsights: ['Order within budget', 'Vendor performance good', 'Delivery timeline realistic'],
      keyMetrics: {
        averageItemCost: '$1,312.50',
        discountApplied: '5%',
        taxAmount: '$1,181.25',
        shippingCost: '$150.00'
      },
      alerts: ['Delivery date approaching'],
      performanceScore: 92.5
    },
    {
      id: 'PO-002',
      orderNumber: 'PO-2024-002',
      vendor: 'Office Supplies Inc',
      status: 'Pending',
      orderDate: '2024-02-14',
      expectedDelivery: '2024-02-20',
      totalAmount: '$2,450.00',
      currency: 'USD',
      items: 8,
      category: 'Office Supplies',
      department: 'Administration',
      createdBy: 'Mike Wilson',
      approvedBy: null,
      isActive: true,
      tags: ['office-supplies', 'pending', 'low-value'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 23,
      downloadCount: 3,
      aiInsights: ['Awaiting approval', 'Vendor reliable', 'Standard office supplies'],
      keyMetrics: {
        averageItemCost: '$306.25',
        discountApplied: '0%',
        taxAmount: '$196.00',
        shippingCost: '$50.00'
      },
      alerts: ['Awaiting approval'],
      performanceScore: 78.3
    },
    {
      id: 'PO-003',
      orderNumber: 'PO-2024-003',
      vendor: 'Global Manufacturing',
      status: 'Delivered',
      orderDate: '2024-02-10',
      expectedDelivery: '2024-02-18',
      totalAmount: '$45,200.00',
      currency: 'USD',
      items: 25,
      category: 'Manufacturing Equipment',
      department: 'Production',
      createdBy: 'Lisa Chen',
      approvedBy: 'Robert Davis',
      isActive: false,
      tags: ['manufacturing', 'delivered', 'high-value'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 67,
      downloadCount: 12,
      aiInsights: ['Order completed successfully', 'Vendor performance excellent', 'Equipment installed'],
      keyMetrics: {
        averageItemCost: '$1,808.00',
        discountApplied: '8%',
        taxAmount: '$3,616.00',
        shippingCost: '$800.00'
      },
      alerts: [],
      performanceScore: 96.8
    }
  ]);

  // Mock data for vendor management
  const [vendors, setVendors] = useState([
    {
      id: 'VENDOR-001',
      vendorName: 'TechCorp Solutions',
      vendorCode: 'TC001',
      category: 'IT Equipment',
      status: 'Active',
      contactPerson: 'David Miller',
      email: 'david.miller@techcorp.com',
      phone: '+1-555-0123',
      address: '123 Tech Street, Silicon Valley, CA 94000',
      rating: 4.8,
      totalOrders: 45,
      totalValue: '$125,000.00',
      lastOrderDate: '2024-02-15',
      paymentTerms: 'Net 30',
      isActive: true,
      tags: ['it-equipment', 'reliable', 'preferred'],
      isBookmarked: true,
      isStarred: true,
      viewCount: 156,
      downloadCount: 23,
      aiInsights: ['Excellent vendor performance', 'Consistent delivery', 'Competitive pricing'],
      keyMetrics: {
        averageOrderValue: '$2,777.78',
        onTimeDelivery: '98%',
        qualityRating: '4.8/5.0',
        responseTime: '2 hours'
      },
      alerts: ['Preferred vendor status'],
      performanceScore: 94.2
    },
    {
      id: 'VENDOR-002',
      vendorName: 'Office Supplies Inc',
      vendorCode: 'OS002',
      category: 'Office Supplies',
      status: 'Active',
      contactPerson: 'Jennifer Brown',
      email: 'j.brown@officesupplies.com',
      phone: '+1-555-0456',
      address: '456 Office Ave, Business District, NY 10001',
      rating: 4.2,
      totalOrders: 23,
      totalValue: '$8,500.00',
      lastOrderDate: '2024-02-14',
      paymentTerms: 'Net 15',
      isActive: true,
      tags: ['office-supplies', 'standard', 'local'],
      isBookmarked: false,
      isStarred: false,
      viewCount: 89,
      downloadCount: 12,
      aiInsights: ['Good vendor performance', 'Local supplier', 'Standard office supplies'],
      keyMetrics: {
        averageOrderValue: '$369.57',
        onTimeDelivery: '95%',
        qualityRating: '4.2/5.0',
        responseTime: '4 hours'
      },
      alerts: [],
      performanceScore: 82.6
    }
  ]);

  // Calculate statistics
  const stats = {
    totalOrders: purchaseOrders.length,
    pendingOrders: purchaseOrders.filter(po => po.status === 'Pending').length,
    approvedOrders: purchaseOrders.filter(po => po.status === 'Approved').length,
    deliveredOrders: purchaseOrders.filter(po => po.status === 'Delivered').length,
    totalOrderValue: purchaseOrders.reduce((sum, order) => {
      const value = parseFloat(order.totalAmount.replace(/[$,]/g, ''));
      return sum + value;
    }, 0),
    totalVendors: vendors.length,
    activeVendors: vendors.filter(v => v.status === 'Active').length,
    averageVendorRating: vendors.reduce((sum, vendor) => sum + vendor.rating, 0) / vendors.length,
    totalVendorValue: vendors.reduce((sum, vendor) => {
      const value = parseFloat(vendor.totalValue.replace(/[$,]/g, ''));
      return sum + value;
    }, 0)
  };

  const tabs = [
    { id: 'purchase-orders', label: 'Purchase Orders' },
    { id: 'vendor-management', label: 'Vendor Management' },
    { id: 'contracts', label: 'Procurement Contracts' },
    { id: 'analytics', label: 'Procurement Analytics' }
  ];

  // Define columns for Purchase Orders DataTable
  const purchaseOrdersColumns = [
    {
      key: 'orderNumber',
      label: 'Order Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.vendor} • {row.category}
          </div>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '120px',
      render: (status) => {
        const statusConfig = {
          'Approved': { color: '#10b981', bg: '#d1fae5', icon: <CheckCircle size={14} /> },
          'Pending': { color: '#f59e0b', bg: '#fef3c7', icon: <Clock size={14} /> },
          'Delivered': { color: '#6b7280', bg: '#f3f4f6', icon: <CheckCircle size={14} /> },
          'Cancelled': { color: '#ef4444', bg: '#fee2e2', icon: <XCircle size={14} /> }
        };
        const config = statusConfig[status] || statusConfig['Pending'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {status}
          </span>
        );
      }
    },
    {
      key: 'totalAmount',
      label: 'Total Amount',
      width: '120px',
      render: (amount) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{amount}</span>
      )
    },
    {
      key: 'items',
      label: 'Items',
      width: '80px',
      render: (count) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{count}</span>
      )
    },
    {
      key: 'orderDate',
      label: 'Order Date',
      width: '120px',
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      key: 'expectedDelivery',
      label: 'Expected Delivery',
      width: '140px',
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      key: 'department',
      label: 'Department',
      width: '120px',
      render: (dept) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{dept}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Order"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Order"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Define columns for Vendor Management DataTable
  const vendorManagementColumns = [
    {
      key: 'vendorName',
      label: 'Vendor Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.vendorCode} • {row.category}
          </div>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '100px',
      render: (status) => {
        const statusConfig = {
          'Active': { color: '#10b981', bg: '#d1fae5' },
          'Inactive': { color: '#6b7280', bg: '#f3f4f6' },
          'Suspended': { color: '#ef4444', bg: '#fee2e2' }
        };
        const config = statusConfig[status] || statusConfig['Active'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {status}
          </span>
        );
      }
    },
    {
      key: 'rating',
      label: 'Rating',
      width: '100px',
      render: (rating) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ fontWeight: '500', color: '#1f2937' }}>{rating}</span>
          <span style={{ color: '#f59e0b' }}>★</span>
        </div>
      )
    },
    {
      key: 'totalOrders',
      label: 'Total Orders',
      width: '120px',
      render: (count) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{count}</span>
      )
    },
    {
      key: 'totalValue',
      label: 'Total Value',
      width: '120px',
      render: (value) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{value}</span>
      )
    },
    {
      key: 'lastOrderDate',
      label: 'Last Order',
      width: '120px',
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      key: 'paymentTerms',
      label: 'Payment Terms',
      width: '120px',
      render: (terms) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{terms}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Vendor"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Vendor"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Handler functions
  const handleView = (item) => {
    //console.log('Viewing item:', item.orderNumber || item.vendorName);
  };

  const handleExport = (item) => {
    setSelectedItem(item);
    setShowExportModal(true);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      if (activeTab === 'purchase-orders') {
        setPurchaseOrders(prev => prev.filter(order => order.id !== selectedItem.id));
      } else {
        setVendors(prev => prev.filter(vendor => vendor.id !== selectedItem.id));
      }
      setShowDeleteModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error deleting item:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleExportConfirm = async () => {
    setIsProcessing(true);
    try {
      setShowExportModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error exporting report:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{
      padding: '24px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      backgroundColor: '#f8fafc',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1f2937',
          margin: '0 0 8px 0',
          background: 'linear-gradient(135deg, #007B8F 0%, #4A9BA8 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Procurement Integration
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          Streamline procurement processes with integrated purchase orders and vendor management
        </p>
      </div>

      {/* Tabbed Navigation */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{
          display: 'flex',
          borderBottom: '1px solid #e5e7eb',
          gap: '0'
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                color: activeTab === tab.id ? '#007B8F' : '#6b7280',
                borderBottom: activeTab === tab.id ? '3px solid #007B8F' : '3px solid transparent',
                transition: 'all 0.15s ease-in-out',
                fontWeight: '500',
                fontSize: '14px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                position: 'relative',
                marginBottom: '-1px'
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.id === 'purchase-orders' && <ShoppingCart size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'vendor-management' && <Building size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'contracts' && <FileTextIcon size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'analytics' && <BarChart size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Orders</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalOrders}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.pendingOrders} pending, {stats.approvedOrders} approved
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#007B8F20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#007B8F'
          }}>
            <ShoppingCart size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Order Value</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              ${(stats.totalOrderValue / 1000).toFixed(0)}K
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Procurement spend
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#10b98120',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#10b981'
          }}>
            <DollarSignIcon size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Vendors</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalVendors}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.activeVendors} active vendors
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#f59e0b20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b'
          }}>
            <Building size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Avg Vendor Rating</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.averageVendorRating.toFixed(1)}
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Vendor performance
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#ef444420',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ef4444'
          }}>
            <Star size={20} />
          </div>
        </div>
      </div>

      {/* Purchase Orders Tab */}
      {activeTab === 'purchase-orders' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={purchaseOrders}
              columns={purchaseOrdersColumns}
              title={`Purchase Orders (${purchaseOrders.length} orders)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Vendor Management Tab */}
      {activeTab === 'vendor-management' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={vendors}
              columns={vendorManagementColumns}
              title={`Vendor Management (${vendors.length} vendors)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Other Tabs */}
      {activeTab === 'contracts' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Procurement Contracts Dashboard Coming Soon!
        </div>
      )}

      {activeTab === 'analytics' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Procurement Analytics Dashboard Coming Soon!
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Delete Item"
        message={`Are you sure you want to delete "${selectedItem?.orderNumber || selectedItem?.vendorName}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={isDeleting}
      />

      {/* Export Report Modal */}
      <ConfirmationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        onConfirm={handleExportConfirm}
        title="Export Report"
        message={`Export procurement report for "${selectedItem?.orderNumber || selectedItem?.vendorName}"? This will generate a comprehensive report with order details and vendor information.`}
        confirmText="Export"
        cancelText="Cancel"
        type="success"
        isLoading={isProcessing}
      />
    </div>
  );
};

export default ProcurementIntegration;
